var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEventCalendar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_13246",
    "data-name": "Group 13246",
    transform: "translate(-66 -250)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_13244",
    "data-name": "Group 13244"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_18402",
    "data-name": "Rectangle 18402",
    width: 24,
    height: 24,
    transform: "translate(66 250)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Icon_material-event-note",
    "data-name": "Icon material-event-note",
    d: "M21.3,12.3H9.3v2.4h12Zm2.4-8.4H22.5V1.5H20.1V3.9H10.5V1.5H8.1V3.9H6.9A2.389,2.389,0,0,0,4.512,6.3L4.5,23.1a2.4,2.4,0,0,0,2.4,2.4H23.7a2.407,2.407,0,0,0,2.4-2.4V6.3A2.407,2.407,0,0,0,23.7,3.9Zm0,19.2H6.9V9.9H23.7Zm-6-6H9.3v2.4h8.4Z",
    transform: "translate(62.7 248.5)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEventCalendar);
export default __webpack_public_path__ + "static/media/EventCalendar.a43be5cb6624ed76edb1460a527fe8c5.svg";
export { ForwardRef as ReactComponent };